export const PermissionDenied = () => {
  return (
    <h1 className="text-soClean-100 m-auto justify-center text-3xl font-bold tracking-wide">
      PERMISSION DENIED
    </h1>
  );
};
